import { clearStoredUser, getStoredUser, setSessionNotice } from "./session";

const statusMessages = {
  409: "This action is stale or has already been completed. Refresh the page and review the current status.",
  429: "Too many attempts were made. Wait a moment before trying again.",
  500: "CounselVault could not complete the request. Please try again safely.",
  503: "CounselVault is temporarily unavailable. Please try again shortly.",
};

function forbiddenMessage() {
  const role = getStoredUser()?.role;

  if (["facility_admin", "admin"].includes(role)) {
    return "This record is outside your facility or your facility is inactive. Return to your facility workspace.";
  }
  if (role === "attorney") {
    return "Your facility or client authorization does not permit this action. Review your access status.";
  }
  if (role === "inmate") {
    return "This document or action is not available for your account. Contact facility staff if you need assistance.";
  }
  return "Your account does not have permission to perform this action.";
}

export function normalizeApiError(error) {
  const status = error?.response?.status;
  const data = error?.response?.data || {};
  let message = data.message || "Unable to complete the request.";

  if (status === 403) {
    message = /inactive|suspended/i.test(String(data.message || ""))
      ? "This account or facility is inactive. Contact an authorized administrator for assistance."
      : forbiddenMessage();
  }
  if (statusMessages[status]) message = statusMessages[status];
  if (!error?.response) message = "CounselVault could not be reached. Check your connection and try again.";

  error.userMessage = message;
  error.fieldErrors = status === 422 && data.errors ? data.errors : {};

  if (error.response) {
    error.response.data = { ...data, message };
  }

  return error;
}

export function handleUnauthorized(error) {
  if (error?.response?.status !== 401 || !getStoredUser()) return false;

  clearStoredUser();
  setSessionNotice("Your session expired. Sign in again to continue securely.");

  if (window.location.pathname !== "/login") {
    window.location.assign("/login");
  }

  return true;
}

export function getErrorMessage(error, fallback = "Unable to complete the request.") {
  return error?.userMessage || error?.response?.data?.message || fallback;
}

export function getFieldError(error, field) {
  const value = error?.fieldErrors?.[field] || error?.response?.data?.errors?.[field];
  return Array.isArray(value) ? value[0] : value || "";
}
